import moment from 'moment';

const COLUMNAS_EMPLEADOS = [
  { header: 'Número documento', key: 'NumeroDocumento', width: 25 },
  { header: 'Nombre completo', key: 'nombreCompleto', width: 35 },
  { header: 'Cargo', key: 'Cargo', width: 30 },
  { header: 'Compañía', key: 'Compañia', width: 30 },
  { header: 'Sucursal', key: 'Sucursal', width: 30 },
  { header: 'Fecha ingreso', key: 'FechaIngreso', width: 18 },
  { header: 'Fecha contrato hasta', key: 'FechaContratoHasta', width: 22 },
  { header: 'Salario', key: 'Salario', width: 18 },
  { header: 'Tipo contrato', key: 'TipoContrato', width: 22 },
  { header: 'Teléfono', key: 'Telefono', width: 15 },
  { header: 'Bloqueado', key: 'Bloqueado', width: 16 },
];

const COLUMNA_DISPONIBLE = {
  header: 'Disponible',
  key: 'Disponible',
  width: 16,
};

/**
 * Construye la definición de columnas del Excel según si hay convenio activo.
 * @param {Object|null} convenio - Convenio activo (opcional).
 * @returns {Array<Object>} Columnas con header, key y width.
 */
export const construirColumnas = convenio =>
  convenio ? [...COLUMNAS_EMPLEADOS, COLUMNA_DISPONIBLE] : COLUMNAS_EMPLEADOS;

/**
 * Transforma los empleados al formato plano de filas del Excel.
 * @param {Array<Object>} empleados - Lista de empleados a exportar.
 * @param {Object|null} convenio - Convenio activo (opcional).
 * @returns {Array<Object>} Filas listas para agregar a la hoja.
 */
export const construirDatosExportacion = (empleados, convenio) =>
  empleados.map(empleado => ({
    NumeroDocumento: empleado.NumeroDocumento,
    nombreCompleto: empleado.nombreCompleto,
    Cargo: empleado.Cargo,
    Compañia: empleado.DescCompañia,
    Sucursal: empleado.DescripcionSucursal,
    FechaIngreso: moment.utc(empleado.FechaIngreso).format('YYYY-MM-DD'),
    FechaContratoHasta: empleado.FechaContratoHasta
      ? moment.utc(empleado.FechaContratoHasta).format('YYYY-MM-DD')
      : '',
    Salario: empleado.Salario,
    TipoContrato: empleado.TipoContrato?.DescTipoContrato ?? '',
    Telefono: empleado.Telefono,
    Bloqueado: empleado.Bloqueado ? 'X' : '',
    ...(convenio && { Disponible: empleado.Disponible ? 'X' : '' }),
  }));
